import React, { FC } from 'react'
import { Button } from '@/atoms/Button'
import { CaretLeftIcon } from '@/atoms/Icons/CaretLeftIcon'
import { CirclePlayIcon } from '@/atoms/Icons/CirclePlayIcon'
import { CaptionLG } from '@/atoms/Text'
import { EngagementDetailOverlay } from '@/organisms/CollectibleSceneInfo/EngagementDetailOverlay'
import { useCollectiblesPlayerEngagement } from '@/organisms/CollectiblesPlayer/CollectiblesPlayerEngagement/CollectiblesPlayerEngagementContext'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { StoryList } from '../StoriesList'

export const StoryListPanel: FC<{ hideMomentFullscreen?: boolean }> = ({ hideMomentFullscreen }) => {
  const { t } = useTranslate('watch')
  const { closeUserStoriesList, defaultEngagementDetail } = useCollectiblesPlayerEngagement()

  return (
    <EngagementDetailOverlay
      hideMomentFullscreen={hideMomentFullscreen}
      defaultEngagementDetail={defaultEngagementDetail}
    >
      <div className="flex h-full flex-col">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <Button className="mr-1" variant="plain" onClick={closeUserStoriesList}>
              <CaretLeftIcon className="cursor-pointer" size={24} onClick={closeUserStoriesList} />
            </Button>
            <CirclePlayIcon size={20} />
            <Translate t={t} i18nKey="storiesV2">
              <CaptionLG weight="bold">Stories</CaptionLG>
            </Translate>
          </div>
        </div>
        <div className="h-full w-full pt-4">
          <StoryList />
        </div>
      </div>
    </EngagementDetailOverlay>
  )
}
